import apiMember from '@/api/ecommerce/member';
// import apiOption from '@/api/option';

const defaultState = () => ({
	listMember: [],
	paginationMember: '',
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {

};

const mutations = {
	setMember(state, data) {
		state.listMember = data.data
		state.paginationMember = data.pagination;
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataMember(state) {
		Object.assign(state, defaultState())
	}
};

const actions = {
	getMember({ commit, dispatch }, params) {
		apiMember.getDataMember(params).then(({ data: { data } }) => {
			commit('setMember', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setMember', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	async exportMember({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiMember.exportMember(params).then(({ data: { data } }) => {
			dispatch('success', data.results.message, { root: true })
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Pelanggan'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	getNewMember({ commit, dispatch }, params) {
		apiMember.getDataNewMember(params).then(({ data: { data } }) => {
			commit('setMember', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setMember', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	async exportNewMember({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiMember.exportNewMember(params).then(({ data: { data } }) => {
			dispatch('success', data.results.message, { root: true })
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Pelanggan'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	resendRegistration({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiMember.resendRegistration(params).then(res => {
				const data = res.data;
				dispatch('success', data.message, { root: true })
				resolve(true)
			}).catch( err => {
				const data = err.response.data
				dispatch("errorHandler", data, { root: true })
				reject(false)
			});
		})
	},
	updateMember({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiMember.updateMember(params).then(res => {
				const data = res.data;
				dispatch('success', data.message, { root: true })
				resolve(true)
			}).catch( err => {
				const data = err.response.data
				dispatch("errorHandler", data, { root: true })
				reject(false)
			});
		})
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			default:
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.message
			}, { root: true });
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};